module.exports = __webpack_public_path__ + "img/avaliacao_alt.963a8d09.webp";